import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import moment from "moment"
import { createTenantFeatureFlag, fetchTenantAttestStats, fetchTenantBookingStats, fetchTenantFeatureFlags, fetchTenantProjectFormStats, removeTenantFeatureFlag, updateTenantFeatureFlag } from "../app/actions";

import { Button, Table } from "react-bootstrap"
import AddEditTenantFeatureFlagModal from "./AddEditTenantFeatureFlagModal";


const TenantFeatureFlags = ({tenant}) => {
    const [editTenantFeatureFlag, setEditTenantFeatureFlag] = useState(null)
    const [showAddEditModal, setShowAddEditModal] = useState(false)
    const loadingTenantFeatureFlags = useSelector(store => store.app.loadingTenantFeatureFlags);
    const tenantFeatureFlags = useSelector(store => store.app.tenantFeatureFlags);
    const tenantAttestStats = useSelector(store => store.app.tenantAttestStats);
    const fetchingTenantAttestStats = useSelector(store => store.app.fetchingTenantAttestStats);
    const tenantProjectFormStats = useSelector(store => store.app.tenantProjectFormStats);
    const fetchingTenantProjectFormStats = useSelector(store => store.app.fetchingTenantProjectFormStats);
    const tenantBookingStats = useSelector(store => store.app.tenantBookingStats);
    const fetchingTenantBookingStats = useSelector(store => store.app.fetchingTenantBookingStats);
    const tenantRecord = useSelector(store => store.app.tenant);
    const dispatch = useDispatch();
    useEffect(() => {
        loadFeatureFlags()
    }, [tenant])

    const loadFeatureFlags = () => {
        dispatch(fetchTenantFeatureFlags("", {TenantID: tenant}))
        dispatch(fetchTenantAttestStats(tenant))
        dispatch(fetchTenantProjectFormStats(tenant))
        dispatch(fetchTenantBookingStats(tenant))
    }

    const hideAddEditModal = () => {
        setShowAddEditModal(false)
    }

    const handleDelete = (tenantFeatureFlag) => {
        if(tenantFeatureFlag.id) {
            dispatch(removeTenantFeatureFlag(tenantFeatureFlag.id))
                .then(()=>{
                    loadFeatureFlags()
                    setShowAddEditModal(false)
                })
        }
    }

    const handleSave = (tenantFeatureFlag) => {
        if(tenantFeatureFlag.id) {
            dispatch(updateTenantFeatureFlag(
                tenantFeatureFlag.id,
                tenant,
                tenantFeatureFlag.FeatureFlagID
            )).then(()=>{
                loadFeatureFlags()
                setShowAddEditModal(false)
            })
        } else {
            dispatch(createTenantFeatureFlag(
                tenant,
                tenantFeatureFlag.FeatureFlagID
            )).then(()=>{
                loadFeatureFlags()
                setShowAddEditModal(false)
            })
        }
    }
    
    return <div>

        <h5 style={{marginBottom: "1em"}}>Turn on these features if the tenant is using them, they are not hidden behind feature flags</h5>
        <div style={{
            display: "grid",
            gridTemplateColumns: "max-content max-content max-content minmax(0, 1fr)",
            columnGap: "0.5em",
            rowGap: "0.75em",
            alignItems: "baseline",
            border: "1px solid #ccc",
            padding: "1em",
            borderRadius: "1em",
            marginBottom: "2em"
        }}>
            <span>Attests created:</span>
            <span style={{ fontWeight: "bold" }}>
                {fetchingTenantAttestStats
                    ? "…"
                    : tenantAttestStats != null
                      ? tenantAttestStats.attest_count
                      : "—"}
            </span>
            <span>Last created:</span>
            <span style={{ fontWeight: "bold" }}>
                {fetchingTenantAttestStats
                    ? "…"
                    : tenantAttestStats != null && tenantAttestStats.last_attest_created_at
                      ? moment(tenantAttestStats.last_attest_created_at).format("LL")
                      : "—"}
            </span>
            <span>Project forms:</span>
            <span style={{ fontWeight: "bold" }}>
                {fetchingTenantProjectFormStats
                    ? "…"
                    : tenantProjectFormStats != null
                      ? tenantProjectFormStats.project_form_count
                      : "—"}
            </span>
            <span>Last created:</span>
            <span style={{ fontWeight: "bold" }}>
                {fetchingTenantProjectFormStats
                    ? "…"
                    : tenantProjectFormStats != null && tenantProjectFormStats.last_project_form_created_at
                      ? moment(tenantProjectFormStats.last_project_form_created_at).format("LL")
                      : "—"}
            </span>
            <span>Timeplan Bookings:</span>
            <span style={{ fontWeight: "bold" }}>
                {fetchingTenantBookingStats
                    ? "…"
                    : tenantBookingStats != null
                      ? tenantBookingStats.booking_count
                      : "—"}
            </span>
            <span>Last created:</span>
            <span style={{ fontWeight: "bold" }}>
                {fetchingTenantBookingStats
                    ? "…"
                    : tenantBookingStats != null && tenantBookingStats.last_booking_created_at
                      ? moment(tenantBookingStats.last_booking_created_at).format("LL")
                      : "—"}
            </span>
        </div>

        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            <h5>Feature flags</h5>
            <Button onClick={()=>{
                setEditTenantFeatureFlag(null);
                setShowAddEditModal(true);
            }}>Add feature flag</Button>
        </div>
        <br/>
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>#</th>
                    <th>Feature ID</th>
                    <th>Feature Name</th>
                    <th>Feature Description</th>
                    <th>Price per month</th>
                    <th>In Contract</th>
                    <th>Updated</th>
                    <th>Created</th>
                </tr>
            </thead>
            <tbody>
                {!loadingTenantFeatureFlags && tenantFeatureFlags && tenantFeatureFlags.map(tenantFeatureFlag => {
                    return <tr key={tenantFeatureFlag.id} onClick={()=>{
                        setShowAddEditModal(true)
                        setEditTenantFeatureFlag(tenantFeatureFlag)
                    }}>
                        <td>{tenantFeatureFlag.id}</td>
                        <td>{tenantFeatureFlag.FeatureFlagID}</td>
                        <td>{tenantFeatureFlag.FeatureName}</td>
                        <td>{tenantFeatureFlag.FeatureDescription}</td>
                        <td>{tenantFeatureFlag.PricePerMonth}</td>
                        <td onClick={(e) => e.stopPropagation()}>
                            <input
                                type="checkbox"
                                disabled={tenantRecord.FeaturesAdjusted}
                                checked={tenantFeatureFlag.InContract}
                                onChange={(e) => {
                                    const next = e.target.checked;
                                    dispatch(
                                        updateTenantFeatureFlag(
                                            tenantFeatureFlag.id,
                                            tenant,
                                            tenantFeatureFlag.FeatureFlagID,
                                            next
                                        )
                                    ).then(() => {
                                        loadFeatureFlags()
                                    })
                                }}
                            />
                        </td>
                        <td>{tenantFeatureFlag.updated_at}</td>
                        <td>{tenantFeatureFlag.created_at}</td>
                    </tr>
                })}
                
            </tbody>
        </Table>
        <AddEditTenantFeatureFlagModal editTenantFeatureFlag={editTenantFeatureFlag} show={showAddEditModal} onHide={hideAddEditModal} onSave={handleSave} onDelete={handleDelete}/>
    </div>
} 

export default TenantFeatureFlags
